import { Typography } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

export default function Hoverable({ render }) {
  const [hovered, setHovered] = useState(false);
  return (
    <Typography.Text
      onMouseEnter={() => setHovered(true)}
      onMouseOver={() => setHovered(true)}
      onFocus={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {render(hovered)}
    </Typography.Text>
  );
}

Hoverable.propTypes = {
  render: PropTypes.func.isRequired,
};
